
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 83 78"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.263 18.59c-4.993-7.367-5.735-14.776 2.629-14.818 8.632-.044 5.344 8.02 3.614 12.265a36.617 36.617 0 00-.59 1.502c-1.21 3.428-3.752 3.855-5.653 1.05zm1.459-3.135c.696 1.395 1.627 1.182 2.07-.523.052-.203.129-.457.216-.747.633-2.111 1.837-6.123-1.323-6.102-3.063.022-2.79 3.707-.963 7.372z","fill":"#FEB51F"}}),_c('path',{attrs:{"d":"M33.066 77.29c4.424-.383 8.192-4.482 8.169-8.885-.002-.322-15.075-.286-16.451 1.451-3.155 3.986 5.204 7.7 8.282 7.434z","fill":"#FEB51F"}}),_c('path',{attrs:{"d":"M64.893 63.742c.594-3.439-3.318-7.746-4.568-10.73-5.163-12.333-1.831-19.442-8.953-30.753-4.45-7.067-11.797-10.634-18.895-10.515-7.098-.119-14.445 3.448-18.895 10.515C6.46 33.57 9.792 40.68 4.629 53.014c-1.25 2.983-5.162 7.29-4.568 10.73 1.787 10.341 63.04 10.366 64.832 0z","fill":"#FFD56A"}}),_c('path',{attrs:{"d":"M30.366 58.83c-9.843 0-19.038-1.374-25.588-4.123a1.242 1.242 0 01-.666-1.629c.267-.632 1-.93 1.635-.663 12.389 5.198 35.766 5.175 53.22-.052a1.249 1.249 0 011.555.833 1.243 1.243 0 01-.836 1.549c-9.094 2.723-19.528 4.085-29.32 4.085z","fill":"#FEB51F"}}),_c('path',{attrs:{"d":"M36.835 21.952c-1.99 36.427 45.039 25.78 45.658 4.662.961-32.254-43.909-36.832-45.658-4.662z","fill":"#79E3AA"}}),_c('path',{attrs:{"d":"M66.86 15.714a2.175 2.175 0 00-1.497.56c-5.345 4.443-4.637 5.387-9.77 10.024-.692-.759-1.375-1.521-1.995-2.348-.38-.54-.7-1.121-.952-1.732-.953-2.407-5.138-.616-3.747 1.994.666 1.635 4.666 7.09 6.44 7.136 3.153.088 6.829-6.9 12.89-11.958a2.129 2.129 0 00-1.382-3.676h.012z","fill":"#fff"}})])
          )
        }
      }
    